import { gql } from '@apollo/client';

export default gql`
  fragment CourseListItem on Course {
    _id
    name
    academy {
      _id
      name
      logoImageUrl
    }
  }
`;
